<template>
  <Button
    icon="pi pi-arrow-left"
    class="p-button-rounded p-button-outlined back"
    @click="onClick"
  />
</template>

<script>
import store from "../../store";
import { useRouter } from "vue-router";

export default {
  props: {
    callback: {
      type: Function,
      default: () => {},
    },
  },
  setup(props) {
    const router = useRouter();
    const onClick = () => {
      props.callback();
      const breadcrumbs = store.state.general.breadcrumbs;
      const targetIndex =
        breadcrumbs.length > 1 ? breadcrumbs.length - 2 : breadcrumbs.length - 1;
      const target = breadcrumbs[targetIndex];
      const fallback = "/home";
      router.push({ path: target?.to || fallback });
    };
    return { store, onClick };
  },
};
</script>

<style scoped>
.back {
  color: var(--primary-dark) !important;
  margin: 0 1rem 0 2rem;
  width: 2rem !important;
  height: 2rem !important;
}
.back:hover {
  color: var(--primary) !important;
  background-color: #ffffff !important;
  box-shadow: none !important;
}
.back:focus,
.back:active {
  color: var(--primary-dark) !important;
  background-color: #ffffff !important;
  box-shadow: none !important;
}
</style>
